(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider
      .state('member.project.faceDetectionsSearch', {
        url: '/face-detections-search',
        component: 'faceDetectionsSearch',
        redirectTo: 'member.project.faceDetectionsSearch.search',
        authenticated: true,
        resolve: {
          module: [
            '$ocLazyLoad',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([
                window.assetsPath + '/js/app/face-detections-search.module.min.js',
              ]);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"modules.face-detections-search.breadcrumb" | translate}}',
        },
      })
      .state('member.project.faceDetectionsSearch.search', {
        url: '/search',
        template: `<new-front-container path="'face-detections-search'"></new-front-container>`,
        authenticated: true,
        ncyBreadcrumb: {
          label: '{{"modules.face-detections-search.breadcrumbSearch" | translate}}',
        },
      });
  }
})();
